import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"; import { componentToRx } from "app/logic/rx";
 

type Entity = models.SucursalDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas : Column[] = [
    {title: "IATA", cell: x => ({data: x.Iata })},
    {title: "Numero", cell: x => ({data: x.Numero })},
    {title: "Nombre", cell: x => ({data: x.Nombre })},
    {title: "Municipios asignados", cell: x => ({data: x.Municipios.map(x => x.NombreEstado + ", " + x.NombreMunicipio) })},
    {title: "Información comercial", cell: x => ({data: x.InformacionComercial.map(x => x.Año) })},
];

/**Obtiene las columnas del grid */
export function columnas(deps: kea.BotonesListaDeps<Entity>) : Column[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [botones, ... columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/list/columns.tsx